import React from "react";

function About() {
  return (
    <div className="container">
      <h1>About</h1>
      <p>
        Given the worldwide trends in technology, the current state of affairs
        in Serbian IT industry and the overall state of education in Serbia, we
        see a clear opportunity to deliver a modernized education and
        commoditize certain areas of IT outsourcing market.
      </p>

      <p>
        One of the core beliefs of the BIT founding team is in the fact that
        intellectual potential of our country is utterly underutilized. We took
        on recruiting it into IT profession, in exceptionally short time
        periods, via a carefully condensed program.
      </p>
      <p>
        The primary goal of our enterprise is employment of our students. Our
        foremost indicator of our own success is the percentage of candidates
        who upon completing our condensable structured program find themselves
        employed. It is designed to maximize chances for employment - based on
        the worldwide industry trends, locally - tuned in Serbia. It is also
        intended for yearly revisions in order to stay consistent in the top of
        the rapidly developing local IT market, effectively increasing the
        placement rate of our future candidates. BIT GRADUATES ARE EQUIPPED WITH
        SKILLS TO QUICKLY JOIN AN ENGINEERING TEAM AND START NEW CAREER IN IT.
      </p>
    </div>
  );
}

export default About;
